export default "__VITE_ASSET__iOODOvoj__"